<template lang="pug">

  div.container

    .half-width.margin-auto
      h3.title !Hola, {{username}}¡

</template>

<script>
export default {
  name: 'login',
  data () {
    return {
      username: localStorage.getItem('nombre'),
      password: '',
      errorMessage: '',
      isLoading: false
    }
  },
  methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
@import('https://cdnjs.cloudflare.com/ajax/libs/bulma/0.4.4/css/bulma.min.css')
</style>



// WEBPACK FOOTER //
// Admin_View.vue?0cece719